module.exports = __webpack_public_path__ + "img/group-s1.f8967cef.png";